import { WarningCardModal } from "./WarningCardModal";

export default WarningCardModal;
